import React from "react";
import {Edit,useRecordContext,required,FormDataConsumer,FunctionField,SimpleForm,TextInput,TextField, Toolbar, ListButton,SaveButton,} from "react-admin";

import { InfluencerStatusSelectInput } from "../../UI/Input/SelectInput";
import { RichTextInput } from 'ra-input-rich-text';

import Grid from "@material-ui/core/Grid";


const PageTitle = () => {
  const record = useRecordContext();
  return <span>Raise Ticket for {record ? `${record.profile_id}` : ''}</span>;
};
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};
const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="list" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);

const RaiseTicketEdit = (props) => {
  
  return (
    <Edit title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm warnWhenUnsavedChanges toolbar={<FormToolbar />}  redirect="list" defaultValues={{ action: "full" }}>       
          <SanitizedGrid container spacing={2} fullWidth>
            <Grid item sm={12} lg={4}>
              <TextInput disabled label="Profile ID" source="profile_id" fullWidth />
            </Grid>
              <Grid item sm={12}  lg={4}>
                <TextInput disabled source="email" label="Email" fullWidth/>
            </Grid>
            <Grid item sm={12}  lg={4}>
               <TextInput disabled source="whatsapp" label="WhatsApp" fullWidth/>
            </Grid>
          </SanitizedGrid>
          <SanitizedGrid container spacing={3} fullWidth>
            <Grid item sm={12}  lg={12}>
              
                <TextInput disabled label="Title" source="title" fullWidth/>
            </Grid>
                
          </SanitizedGrid>
          <SanitizedGrid container spacing={3} fullWidth>
            <Grid item sm={12}  lg={12}>
              
                <RichTextInput disabled label="Description" source="description" fullWidth/>
            </Grid>
                
          </SanitizedGrid>
          <SanitizedGrid container spacing={3} fullWidth>
           
           
            <Grid item sm={12}  lg={6}>
            <FunctionField source="status" label="Status" render={record => {  
              
                return (<InfluencerStatusSelectInput validate={required()} label="Status" fullWidth source="status"/>)
              
            }} /> 
            </Grid>     
            <Grid item sm={12}  lg={6}>
            <FormDataConsumer>
              {({ formData, ...rest }) =>
                formData.status === "Reject" && (
                  <TextInput source="decline_reason"  label="Reject Reason" fullWidth validate={required()}/>
                )
              }
            </FormDataConsumer>
            <FormDataConsumer>
              {({ formData, ...rest }) =>
                formData.status === "Approved" && (
                  <TextInput  label="Commends" source="commends" fullWidth validate={required()} />
                )
              }
            </FormDataConsumer>
            
            </Grid>       
          </SanitizedGrid>
          
      </SimpleForm>
    </Edit>
  );
};

export default RaiseTicketEdit;
